export enum OrderType {
  ASAP = 'ASAP',
  LATER = 'LATER',
  TO_TABLE = 'TO_TABLE',
  TO_ROOM = 'TO_ROOM',
  AT_THE_BAR = 'AT_THE_BAR',
  TO_TABLE_WITH_RESERVATION = 'TO_TABLE_WITH_RESERVATION',
}
